function initFooterAccordions() {
  const footerWidgets = document.querySelectorAll(
    ".site-footer .footer-widget"
  );
  const tabletBreakpoint = 768;

  footerWidgets.forEach((widget) => {
    const titleElement = widget.querySelector(".widget-title");
    // Only target widgets that are meant to be accordions: those with ul.footer-menu
    const contentElement = widget.querySelector("ul.footer-menu");

    if (titleElement && contentElement) {
      widget.classList.add("js-accordion-widget"); // Mark as accordion-capable

      const toggleButton = document.createElement("button");
      toggleButton.classList.add("footer-widget-toggle");
      toggleButton.setAttribute("aria-expanded", "false");
      toggleButton.setAttribute("type", "button");

      const titleTextNode = Array.from(titleElement.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE
      );
      const titleText = titleTextNode
        ? titleTextNode.textContent.trim()
        : "section";
      toggleButton.setAttribute("aria-label", `Toggle ${titleText}`);

      toggleButton.innerHTML =
        '<span class="icon-toggle" aria-hidden="true"></span>'; // Icon styled by CSS

      titleElement.appendChild(toggleButton);
      titleElement.classList.add("js-accordion-title");

      titleElement.addEventListener("click", (event) => {
        if (event.target.closest("a")) {
          return;
        }

        if (window.innerWidth < tabletBreakpoint) {
          const isOpen = widget.classList.toggle("is-open");
          toggleButton.setAttribute("aria-expanded", isOpen.toString());
        }
      });

      const updateAccordionState = () => {
        if (window.innerWidth >= tabletBreakpoint) {
          widget.classList.remove("is-open");
          toggleButton.setAttribute("aria-expanded", "false"); // Button is hidden, so not expanded
        } else {
          // On mobile/tablet, reflect the .is-open class for aria-expanded
          toggleButton.setAttribute(
            "aria-expanded",
            widget.classList.contains("is-open").toString()
          );
        }
      };

      // Initial check
      updateAccordionState();
      // Update on resize
      window.addEventListener("resize", updateAccordionState);
    }
  });
}

function initScrollToTop() {
  const scrollToTopBtn = document.getElementById("scroll-to-top");

  if (!scrollToTopBtn) {
    return;
  }

  const scrollThreshold = 300; // Pixels to scroll before button appears

  // Show/hide button based on scroll position
  const toggleVisibility = () => {
    if (window.scrollY > scrollThreshold) {
      scrollToTopBtn.classList.add("is-visible");
    } else {
      scrollToTopBtn.classList.remove("is-visible");
    }
  };

  // Scroll to top on click
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisibility);
  scrollToTopBtn.addEventListener("click", scrollToTop);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initFooterAccordions();
    initScrollToTop();
  });
} else {
  initFooterAccordions();
  initScrollToTop();
}
